"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const short_uuid_1 = __importDefault(require("short-uuid"));
const evaluateVarFactoryWithProccessor_1 = __importDefault(require("./evaluateVarFactoryWithProccessor"));
const FirebaseDatabaseCore_1 = __importDefault(require("../FirebaseDatabaseCore"));
const flatAppUser_1 = __importDefault(require("../shared/flatAppUser"));
const buildRoutingHandler_1 = __importDefault(require("./buildRoutingHandler"));
const createFunctionLogger_1 = __importDefault(require("./createFunctionLogger"));
const valueIsNullOrUndef_1 = __importDefault(require("../typeAssertions/valueIsNullOrUndef"));
const applicationStateActionBuilders_1 = require("../shared/applicationStateActionBuilders");
const serverFunctions_1 = require("../firebase/serverFunctions");
const ensureCorrectProcessorUserInfo_1 = __importDefault(require("../shared/ensureCorrectProcessorUserInfo"));
const setObjectPropByPath_1 = __importDefault(require("../shared/setObjectPropByPath"));
const extractProcessorInfoFromFirebaseRef = async (userRef) => {
    const valuesSnaps = (await Promise.all([
        userRef.child('name').once('value'),
        userRef.child('email').once('value'),
        userRef.child('phone').once('value'),
        userRef.child('photoURL').once('value'),
        userRef.child('customData').once('value'),
    ])).map((snap) => snap.val());
    return (0, ensureCorrectProcessorUserInfo_1.default)({
        name: valuesSnaps[0],
        email: valuesSnaps[1],
        phone: valuesSnaps[2],
        photoURL: valuesSnaps[3],
        customData: valuesSnaps[4],
    });
};
const RootProcessor = ({ dispatch, isInDevelopment, getApplicationState, firebase, platformOS, environment, alert, getLanguageLocale, onClearListeners, }) => {
    const getRoutingState = () => getApplicationState().routing.stack;
    const updateRoutingState = (newState) => {
        dispatch((0, applicationStateActionBuilders_1.buildAppUpdateRouteStackAction)(newState));
    };
    const getAppId = () => getApplicationState().appId;
    const routing = (0, buildRoutingHandler_1.default)({
        maxRoutesOnStack: 40,
        getRoutingStack: getRoutingState,
        onSetRoutingStack: updateRoutingState,
    });
    const processorObject = {
        alert,
        dispatch,
        isInDevelopment,
        userInfo: undefined,
        databaseCore: undefined,
        firebase,
        cloud: {
            rendererLogIn: (params) => (0, serverFunctions_1.rendererLogIn)(firebase.functions())(params),
            rendererUpdateCloudMessageToken: (params) => (0, serverFunctions_1.rendererUpdateCloudMessageToken)(firebase.functions())(params),
            saveMemberData: (params) => (0, serverFunctions_1.saveMemberData)(firebase.functions())(params),
            rendererChangeMyPassword: (params) => (0, serverFunctions_1.rendererChangeMyPassword)(firebase.functions())(params),
            executeAppProcessCloud: (params) => (0, serverFunctions_1.executeAppProcessCloud)(firebase.functions())(params),
            renderForgetPassword: (params) => (0, serverFunctions_1.renderForgetPassword)(firebase.functions())(params),
        },
        userUid: undefined,
        platformOS,
        getLanguageLocale,
        environment,
        arrayIntervals: [],
        routing,
        appParams: {},
        controlsExtraData: {},
        setAppParam: (paramKey, paramValue) => {
            processorObject.appParams[paramKey] = paramValue;
        },
        setControlExtraData: ({ controlId, path, data }) => {
            const finalPath = path ? `${controlId}.${path}` : controlId;
            processorObject.controlsExtraData = (0, setObjectPropByPath_1.default)(processorObject.controlsExtraData, finalPath.split('.'), data);
        },
        createFunctionLogger: async (functionId) => {
            const appId = getAppId();
            if ((0, valueIsNullOrUndef_1.default)(appId)) {
                throw new Error('To build a funciton logger an app id is required');
            }
            return (0, createFunctionLogger_1.default)({
                appId,
                database: firebase.database(),
                functionId,
                generateId: () => short_uuid_1.default.generate(),
                getTimestamp: () => Date.now(),
            });
        },
        openInputDialog: (params) => {
            dispatch((0, applicationStateActionBuilders_1.buildAppUpdateInputdialogContextAction)(params));
        },
        openAlert: (params) => {
            dispatch((0, applicationStateActionBuilders_1.buildAppUpdateAlertContextAction)(params));
        },
        openConfirmAlert: (params) => {
            dispatch((0, applicationStateActionBuilders_1.buildAppUpdateConfirmAlertContextAction)(params));
        },
        openAdMobInterstitialAds: (params) => {
            dispatch((0, applicationStateActionBuilders_1.buildAppUpdateAdmobInterstitialContextAction)(params));
        },
        getProjectId: () => getApplicationState().projectId,
        getAppId,
        setUserUid: (userUid) => {
            processorObject.userUid = userUid;
        },
        updateControlPropByPathIfExist: (params) => {
            dispatch((0, applicationStateActionBuilders_1.buildAppUpdateControlPropByPathIfExistAction)(params));
        },
        setUserInfo: (newUserInfo) => {
            processorObject.userInfo = newUserInfo;
        },
        getRoutingState,
        getIsBottomMenuOpened: () => {
            var _a, _b, _c, _d;
            const currentPageId = routing.getCurrentPageId();
            if (!currentPageId) {
                return false;
            }
            const currentPage = (_b = (_a = getApplicationState().buildOrders) === null || _a === void 0 ? void 0 : _a.pages) === null || _b === void 0 ? void 0 : _b[currentPageId];
            if (!currentPage) {
                return false;
            }
            const storeFlag = !!((_c = getApplicationState().bottomMenuFlagsByPage) === null || _c === void 0 ? void 0 : _c[currentPageId]);
            return storeFlag && !!((_d = currentPage.bottomMenuSheet) === null || _d === void 0 ? void 0 : _d.active);
        },
        getBuildOrders: () => getApplicationState().buildOrders,
        getFlattedControls: () => getApplicationState().flattedControls,
        getAPIInformationById: (apiId) => { var _a, _b; return (_b = (_a = processorObject.getBuildOrders()) === null || _a === void 0 ? void 0 : _a.apis) === null || _b === void 0 ? void 0 : _b[apiId]; },
        getControlInfoById: (controlId) => { var _a; return (_a = processorObject.getFlattedControls()) === null || _a === void 0 ? void 0 : _a[controlId]; },
        getControlById: (controlId) => {
            const controlInfo = processorObject.getControlInfoById(controlId);
            if (!controlInfo) {
                return null;
            }
            return controlInfo.control;
        },
        updateRoutingState,
        updateControlById: (updateInstruction) => {
            dispatch((0, applicationStateActionBuilders_1.buildAppUpdateControlByIdAction)(updateInstruction));
        },
        updateRenderDBCache: (newData) => {
            dispatch((0, applicationStateActionBuilders_1.buildAppUpdateDbCacheAction)(newData));
        },
        setIsSideMenuOpened: (flag) => {
            dispatch((0, applicationStateActionBuilders_1.buildAppSetIsSideMenuOpenedAction)(flag));
        },
        setTransitionSideMenu: (transition) => {
            dispatch((0, applicationStateActionBuilders_1.buildAppSetTransitionSideMenuAction)(transition));
        },
        setIsBottomMenuOpened: (flag) => {
            const currentPageId = routing.getCurrentPageId();
            if (!currentPageId) {
                return;
            }
            dispatch((0, applicationStateActionBuilders_1.buildAppSetIsBottomMenuOpenedAction)({
                flag,
                pageId: currentPageId,
            }));
        },
        setIsLoadingPageOpened: (context) => {
            dispatch((0, applicationStateActionBuilders_1.buildAppSetIsLoadingPageOpenedAction)(context));
        },
        openCamera: (params) => {
            dispatch((0, applicationStateActionBuilders_1.buildAppOpenCameraAction)(params));
        },
        updateApplicationPaletteColors: (params) => {
            dispatch((0, applicationStateActionBuilders_1.buildAppUpdatePaletteColorsActionAction)(params));
        },
        cleanListeners: () => {
            var _a;
            processorObject.cleanAllListUpdaters();
            if ((_a = processorObject.databaseCore) === null || _a === void 0 ? void 0 : _a.cleanListeners) {
                processorObject.databaseCore.cleanListeners();
            }
            processorObject.cancelGeoQuery();
            processorObject.clearTimers();
            processorObject.cleanGeoFireListeners();
            processorObject.clearIntervals();
            processorObject.localStorage.cleanListeners();
            if (onClearListeners) {
                onClearListeners();
            }
        },
        controlListUpdatersById: {},
        registerListUpdater: (controlId, upcater) => {
            processorObject.controlListUpdatersById[controlId] = upcater;
        },
        cleanAllListUpdaters: () => {
            Object.entries(processorObject.controlListUpdatersById)
                .forEach(([, listUpdater]) => {
                if (listUpdater) {
                    listUpdater.cancel();
                }
            });
            processorObject.controlListUpdatersById = {};
        },
        geoFireListeners: [],
        registerGeoFireListener: ({ path, listener }) => {
            processorObject.geoFireListeners.push({ path, listener });
        },
        cleanGeoFireListeners: () => {
            processorObject.geoFireListeners.forEach(({ path, listener }) => {
                firebase.database().ref(path).off('value', listener);
            });
            processorObject.geoFireListeners = [];
        },
        geoQuerySubscriptions: [],
        cancelGeoQuery: () => {
            processorObject.geoQuerySubscriptions.forEach((subscription) => {
                subscription.cancel();
            });
            processorObject.geoQuerySubscriptions = [];
        },
        registerGeoQuery: (subscriptions) => {
            processorObject.geoQuerySubscriptions = [
                ...processorObject.geoQuerySubscriptions,
                ...subscriptions,
            ];
        },
        arrayTimers: [],
        registerTimer: ({ timer }) => {
            processorObject.arrayTimers.push(timer);
        },
        clearTimers: () => {
            processorObject.arrayTimers.forEach((timer) => {
                clearInterval(timer);
            });
            processorObject.arrayTimers = [];
        },
        controlsRunContext: {},
        getControlRunContext: (controlId) => processorObject.controlsRunContext[controlId],
        setControlRunContext: (controlId, context) => {
            processorObject.controlsRunContext[controlId] = context;
        },
        destroy: () => {
            processorObject.cleanListeners();
        },
        registerInterval: (onDone, time) => {
            const interval = setInterval(() => {
                onDone();
            }, time);
            processorObject.arrayIntervals.push(interval);
            return interval;
        },
        clearIntervals: () => {
            processorObject.arrayIntervals.forEach((interval) => {
                clearInterval(interval);
            });
            processorObject.arrayIntervals = [];
        },
        stopInterval: (interval) => {
            const indexInterval = processorObject.arrayIntervals.findIndex((interId) => interId === interval);
            clearInterval(interval);
            processorObject.arrayIntervals.splice(indexInterval, 1);
        },
        localStorage: {
            clean: () => {
                dispatch((0, applicationStateActionBuilders_1.buildAppCleanLocalStorageAction)());
            },
            update: (payload) => {
                dispatch((0, applicationStateActionBuilders_1.buildAppUpdateLocalStorageAction)(payload));
            },
            addListener: (payload) => {
                dispatch((0, applicationStateActionBuilders_1.buildAppAddLocalStorageListenerAction)(payload));
            },
            cleanListeners: () => {
                dispatch((0, applicationStateActionBuilders_1.buildAppCleanLocalStorageListenersAction)());
            },
            getData: () => getApplicationState().localStorage.data,
        },
        updateControlToList: (payload) => {
            dispatch((0, applicationStateActionBuilders_1.buildAppUpdateControlToListAction)(payload));
        },
        updateSwiperContent: (payload) => {
            dispatch((0, applicationStateActionBuilders_1.buildAppUpdateSwiperContentAction)(payload));
        },
        addItemsToFlatList: (payload) => {
            dispatch((0, applicationStateActionBuilders_1.buildAppAddItemsToFlatListAction)(payload));
        },
        loadFirebaseUserInfo: async () => {
            const appId = processorObject.getAppId();
            const projectId = processorObject.getProjectId();
            if (!appId || !projectId) {
                return;
            }
            let memberValue = {
                name: null,
                email: null,
                phone: null,
                photoURL: null,
                customData: undefined,
            };
            const { currentUser } = processorObject.firebase.auth();
            if (currentUser) {
                const memberRef = processorObject.firebase.database().ref(`projects/${projectId}/apps/${appId}/members/${currentUser.uid}`);
                memberValue = await extractProcessorInfoFromFirebaseRef(memberRef);
            }
            let userValue = {
                name: null,
                email: null,
                phone: null,
                photoURL: null,
            };
            if (currentUser) {
                const userRef = processorObject.firebase.database().ref(`users/${currentUser.uid}`);
                userValue = await extractProcessorInfoFromFirebaseRef(userRef);
            }
            const flattedUser = (currentUser && (0, flatAppUser_1.default)(currentUser)) || undefined;
            processorObject.setUserInfo({
                name: memberValue.name || userValue.name || (flattedUser === null || flattedUser === void 0 ? void 0 : flattedUser.displayName) || null,
                phone: memberValue.phone || userValue.phone || (flattedUser === null || flattedUser === void 0 ? void 0 : flattedUser.phoneNumber) || null,
                photoURL: memberValue.photoURL
                    || userValue.photoURL || (flattedUser === null || flattedUser === void 0 ? void 0 : flattedUser.photoURL) || null,
                customData: memberValue.customData,
                email: memberValue.email || (flattedUser === null || flattedUser === void 0 ? void 0 : flattedUser.email) || null,
            });
        },
        openImageViewer: (params) => {
            dispatch((0, applicationStateActionBuilders_1.buildAppOpenImageViewer)(params));
        },
    };
    processorObject.routing.subscribe(() => {
        processorObject.cleanListeners();
    });
    if (!processorObject.databaseCore) {
        processorObject.userInfo = undefined;
        processorObject.databaseCore = (0, FirebaseDatabaseCore_1.default)({
            database: firebase.database(),
            getDatabaseCache: () => getApplicationState().dbCache,
        });
    }
    return processorObject;
};
const buildBaseProcessor = ({ alert, dispatch, getApplicationState, isInDevelopment, firebase, platformOS, environment, functionDefinitions, getLanguageLocale, onClearListeners, onReady, }) => {
    const rootProcessor = RootProcessor({
        alert,
        dispatch,
        isInDevelopment,
        getApplicationState,
        firebase,
        platformOS,
        getLanguageLocale,
        environment,
        onClearListeners,
    });
    let unsubscribeFromFirebaseAuthState;
    const baseProcessor = {
        id: short_uuid_1.default.generate(),
        root: rootProcessor,
        copyProcessorWithContext: (newContext) => {
            const newProcessor = Object.assign(Object.assign({}, baseProcessor), { ovewritedPageParams: newContext });
            return Object.assign(Object.assign({}, newProcessor), { evaluateVarFactory: (0, evaluateVarFactoryWithProccessor_1.default)({
                    rootProcessor,
                    processor: newProcessor,
                    functionDefinitions,
                }) });
        },
        destroy: () => {
            if (unsubscribeFromFirebaseAuthState) {
                unsubscribeFromFirebaseAuthState();
            }
            rootProcessor.destroy();
        },
    };
    const processor = Object.assign(Object.assign({}, baseProcessor), { evaluateVarFactory: (0, evaluateVarFactoryWithProccessor_1.default)({
            rootProcessor,
            processor: baseProcessor,
            functionDefinitions,
        }) });
    let onReadyCalledBefore = false;
    unsubscribeFromFirebaseAuthState = firebase.auth().onAuthStateChanged(() => {
        rootProcessor.loadFirebaseUserInfo()
            .then(() => {
            if (onReadyCalledBefore) {
                return;
            }
            onReadyCalledBefore = true;
            onReady(processor);
        });
    });
};
const buildApphiveProcessor = ({ alert, dispatch, getApplicationState, isInDevelopment, firebase, platformOS, getLanguageLocale, environment, functionDefinitions, onClearListeners, }) => new Promise((resolve) => {
    buildBaseProcessor({
        alert,
        dispatch,
        firebase,
        functionDefinitions,
        getApplicationState,
        isInDevelopment,
        platformOS,
        getLanguageLocale,
        environment,
        onClearListeners,
        onReady: resolve,
    });
});
exports.default = buildApphiveProcessor;
